export default "__VITE_ASSET__b754d23e__"